import { render, staticRenderFns } from "./affiliateUserManage.vue?vue&type=template&id=6d9003c8&scoped=true"
import script from "./affiliateUserManage.vue?vue&type=script&lang=js"
export * from "./affiliateUserManage.vue?vue&type=script&lang=js"
import style0 from "./affiliateUserManage.vue?vue&type=style&index=0&id=6d9003c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9003c8",
  null
  
)

export default component.exports